<template>
    <div>
        <div class='g_mobileOn' style="position:fixed;top:65px;right: 20px;z-index:3">
            <s-you-tube id="video_listClub" :club="club" theme="is-info is-small" :init="clubsData.length==0"/>
        </div>
        <modal-visible
            :open="openModalPublic"
            @close="openModalPublic=false"
            :club="clubNew"
        />
        <div class="g_headerDesktop g_desktopOn" >
            <div class="g_menuDesktop" >
                <div class="title is-4" style="float:left;padding-left: 40px">
                    <s-l id="club_title">Mes clubs</s-l>
                     <div  >
                         <s-button icon="search" theme="is-primary" label="Rechercher un club" @onclick="visitClub()"/>
                       &nbsp; <s-button label="Créer votre club" icon="plus" theme="is-primary" @onclick="addClub"/>
                    </div>
                </div>
                <div style="float:right">
                     <s-button icon="running"  theme="is-small is-warning" label="Concours démo" @onclick="concoursTest()"/>
                    <div style="margin-top: 8px;text-align:right">
                    <s-button icon="chalkboard-teacher" theme="is-dark is-small" label="Tutoriel" @onclick="createClubDemo()"/>
                    &nbsp;
                    <s-you-tube id="video_listClub" :club="club" theme="is-info is-small" :init="clubsData.length==0"/>
                    </div>
                </div>
            </div>
           
        </div>
        <div class="g_menuMobile" v-show="!editClubModal">
            <table class="g_menuFooter">
                <tr>
                    <td colspan="5" class="g_headerFooter">
                        Mes clubs
                    </td>
                </tr>
                <tr>
                    <td>
                        <s-button 
                            label="Accueil" 
                            mode="V" 
                            icon="home" 
                            theme="is-light" 
                            @onclick="home()"
                        />
                        
                        
                    </td>
                    
                     <td>
                        <s-button 
                            icon="search" theme="is-primary is-normal" 
                            label="Rechercher un club" 
                            mode="V"
                            @onclick="visitClub()" 
                        />
                    </td>
                     <td>
                            <s-button 
                                label="Créer un club" 
                                mode="V" 
                                icon="plus" 
                                theme="is-success" 
                                @onclick="addClub"/>
                    </td>
                    
                     <td>
                         <s-button icon="chalkboard-teacher" 
                            theme="is-dark" 
                            label="Tutoriel" mode="V" @onclick="createClubDemo()"/>
                    </td>
                    <td>
                        <s-button icon="running" 
                            theme="is-warning" 
                            label="Démo concours" @onclick="concoursTest()" mode="V"/>
                    </td>
                    
                </tr>
            </table>
        </div>
        <div class="sListClubs">
        <div class="smedia" v-for="clubItem in clubsData" v-if="clubItem" v-show="!clubItem.demo">
            <div :class="clubItem.demo ? 'sheaderDemo' : 'sheader'" >
                {{clubItem.name}}
            </div>
            <div class="smediaDescription">
                <div style="display:inline-block;width: 100px;vertical-align:top;" >
                    <p class="image is-64x64" style="margin-left: 20px">
                        <img-file 
                                :ref="'F'+clubItem.id" 
                                :pathFile="'/club/'+clubItem.id" 
                                width="100px" 
                                height="100px" :role="getRole(clubItem)"
                                @onclick="upload('/club/',clubItem.id)"
                                @finish="uploadInProgress = false" 
                                :exists = "clubItem.logo"
                        />
                    </p>
                </div>
                <div style="width: 190px;display:inline-block;">
                    <div class="content">
                    <p>
                       
                        <div v-if="clubItem.type==0" >
                            <span class="icon" >
                                <i class="fas fa-child"></i>
                            </span>&nbsp;&nbsp;Club Familiale
                        </div>
                        <div v-if="clubItem.type==1" >
                                <span class="icon" >
                                <i class="fas fa-umbrella-beach"></i>
                            </span>&nbsp;&nbsp;Club de vacance
                        </div>
                        <div v-if="clubItem.type==2" >
                            <span class="icon" >
                                <i class="fas fa-basketball-ball"></i>
                            </span>
                            &nbsp;&nbsp;Club amateur
                        </div>
                        <div v-if="clubItem.type==3" >
                                <span class="icon">
                                <i class="fas fa-user-tie"></i>
                            </span>&nbsp;&nbsp;Club Pro
                        </div>
                        <div class="president">
                            {{clubItem.president}}&nbsp;
                        </div>
                        <div v-for="user in clubItem.users" v-if="user.role=='owner'" class="owner">
                            <span v-if="user.id!=$store.getters.getUser.id">invité par {{user.pseudo}}
                            </span>
                            <span v-if="user.id==$store.getters.getUser.id" class="gestionnaire"><b>Vous êtes le GESTIONNAIRE</b></span><br/>
                            <span v-if="getRole(clubItem)=='admin'" class="organisateur"> <b>Vous êtes ORGANISATEUR</b>
                            </span>
                        </div>
                        <div>
                            <span v-if="clubItem.nbJoueurs">{{clubItem.nbJoueurs}} </span>
                            <span v-else>0 </span>
                             Membres
                        </div>
                    </p>
                    
                    </div>
                    
               </div>
               <span class="g_desktopOn">
                <div style="display:inline-block;text-align:center; vertical-align:top;width: 40%;" >
                        <div v-if="getRole(clubItem)=='player'">
                            <div class="message" >
                                <s-button theme="is-small is-primary" label="Le club a un message"
                                    icon="info" @onclick="openModalComment(clubItem)"
                                    mode="V"
                                    v-if="(clubItem.comment && clubItem.comment!='')"
                                />
                            </div>
                        </div>
                        
                        <div v-if="getRole(clubItem)=='admin' || getRole(clubItem)=='owner'">
                            <div class="message"  v-if="!(clubItem.comment && clubItem.comment!='')">
                                <s-button theme="is-small is-success" label="Ajouter un message"
                                    icon="plus" @onclick="openModalComment(clubItem)"
                                    mode="V"
                                />
                            </div>
                            <div class="message" v-else>
                                <s-button theme="is-small is-warning" label="Modifier le message"
                                    icon="edit" @onclick="openModalComment(clubItem)"
                                    mode="V"
                                />
                            </div>
                        </div>
                        <div class="buttonGoClub">
                            <s-button 
                                icon="sign-in-alt" 
                                theme="is-primary is-medium" 
                                label="Entrer dans le club" 
                                @onclick="goClubItem(clubItem.id)"
                            />
                        </div>
                        
                    </div>
                </span>
                <span class="g_mobileOn">
                    <div class="buttonInfo">
                         <div v-if="getRole(clubItem)=='player'">
                            <div class="message" >
                                <s-button theme="is-small is-primary" label=""
                                    icon="info" @onclick="openModalComment(clubItem)"
                                    mode="V"
                                    v-if="(clubItem.comment && clubItem.comment!='')"
                                />
                            </div>
                        </div>
                        
                        <div v-if="getRole(clubItem)=='admin' || getRole(clubItem)=='owner'">
                            <div class="message"  v-if="!(clubItem.comment && clubItem.comment!='')">
                                <s-button theme="is-small is-success" label=""
                                    icon="plus" @onclick="openModalComment(clubItem)"
                                    mode="V"
                                />
                            </div>
                            <div class="message" v-else>
                                <s-button theme="is-small is-warning" label=""
                                    icon="edit" @onclick="openModalComment(clubItem)"
                                    mode="V"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="buttonGoClub">
                        <s-button icon="sign-in-alt" theme="is-primary is-medium" label="" 
                                @onclick="goClubItem(clubItem.id)"/>
                       
                    </div>
                </span>
            </div>
            <div class="abonnement" v-if="clubIsSubscription(clubItem) && !clubItem.demo">
                Abonnement activé
            </div>
            <div class="abonnement" v-if="!clubIsSubscription(clubItem) && !clubItem.demo">
               Aucun abonnement
            </div>
             <div class="abonnement" v-if="clubItem.demo && dayDiff(clubItem.create)>0">
               Club démo<br/>
               pourra être supprimé dans {{dayDiff(clubItem.create)}} jours
            </div>
             <div class="abonnementRed" v-if="clubItem.demo && dayDiff(clubItem.create)<0">
               Club démo :<br/>
               Il peut être supprimé à tout moment
            </div>
        </div>
        </div>
        <div v-show="clubsData.length==0" class="g_notItems">
            <s-l id="explainAucunClub">Vous n'appartenez aucun club pour le moment. <br/><br/>Si vous être président d'un club, et souhaitez créer votre club, veuillez cliquer sur le bouton "Créer votre club".<br/><br/>Si vous êtes joueur d'un club, contactez le président de votre club et demandez lui de renseigner votre email sur votre profil.</s-l>
        </div>
        <edit-club 
                :club="clubNew" 
                :role="getRole(club)" 
                v-if="club.length!=0"
                :open="editClubModal"
                @close="closeEdit"
        />
        <s-modal
            :open="modalComment"
            :close="true"
            @close="modalComment=false"
            @save="saveComment"
            :save="getRole(club)=='owner' || getRole(club)=='admin'"
            :deleteData="getRole(club)=='owner' || getRole(club)=='admin'"
            @delete="deleteComment"
            title="Editer un message"
        >
            <div v-if="getRole(club)=='owner' || getRole(club)=='admin'" >
            <quill-editor v-model="comment"
                ref="myQuillEditor"
                :options="editorOption"
                :disabled="false"
                >
            </quill-editor>
            </div>
            <div class="ql-editor"  v-html="comment">
            </div>
        </s-modal>
       <div class="g_mobileOn" style="height: 130px">
       </div>
        
    </div>
</template>
<style scoped>
    .buttonGoClub {
        position: absolute;
        right: 10px;
        top:  180px;
    }
    .buttonInfo {
        position: absolute;
        right: 10px;
        top: 40px;
    }
    .message {
        margin-top: 10px;
        text-align:right;
        margin-left: 20px;
        background-color: white;
        height: 60px;
    }
    .message:hover {
        cursor: pointer;
    }
    .aucunClub {
        padding: 20px;
        font-size: 25px;
        color: black;
    }
    .abonnement {
        font-weight: bolder;
        position: absolute;
        bottom: 20px;
        left: 10px;
    }
    .abonnementRed {
        font-weight: bolder;
        position: absolute;
        bottom: 20px;
        left: 10px;
        color: red;
        font-size: 12px;
    }
    .owner {
        font-size: 14px;
        height: 40px;
        text-align: left;
    }
     .gestionnaire {
       color: red;
    }
     .organisateur {
         color: green;
    }
    @media screen and (max-width: 420px) {
        .sListClubs {
            margin-top: 0px;
            text-align: center;
            margin-left: auto;
            margin-right: auto;
        }
    }
    @media screen and (min-width: 420px) {
        .sListClubs {
            margin-top: 100px;
            text-align: center;
        }
        .smedia {
            margin-left: 20px;
        }
    }
    .smediaDescription {
        border: thin solid var(--bluebg);
        height: 200px;
    }
    .smedia {
        width: 100%;
        max-width: 500px;
        display: inline-block;
        margin-top: 20px;
        height: 240px;
        vertical-align: top;
        color: black;
        background-color: white;
        font-size: 16px;
        text-align: justify;
        position: relative;
    }
    .sheader {
        width: 100%;
        background-color: var(--bluebg);
        border: none;
        color: white;
        font-size: 16px;
        font-weight: bolder;
        padding: 10px;
        z-index: 50;
        margin: 0px;
    }
     .sheaderDemo {
        width: 100%;
        border: none;
        background-color: black;
        color: white;
        font-size: 16px;
        font-weight: bolder;
        padding: 10px;
        z-index: 50;
    }
</style>
<script>
import club_fct from "@/firebase/club"
import joueurVue from "@/views/joueurs/list"
import configMembre from "@/views/club/configMembre.vue"
import importMembres from "@/views/club/importMembres"
import exportMembres from "@/views/club/exportMembres"
import EditClub from "@/views/club/edit.vue"
import joueur from "@/firebase/joueur"
import imgUpload from '@/components/imgUpload.vue'
import imgFile from '@/components/imgStore.vue'
import localisation from '@/views/club/localisation.vue'
import subscription_fct from "@/firebase/subscription"
import firebase_api from "@/firebase/firebase_api"
import SEditor from '@/components/SEditor.vue'
import modalVisible from '@/views/club/modalVisible.vue'
export default {
   
    data() {
        return {
            videoOn: true,
            nav: "list",
            clubsData: [],
            club:{},
            importClient: false,
            uploadPathFile: null,
            clubIdSelected: null,
            uploadInProgress: false,
            configMembre: false,
            subscriptions: null,
            editClubModal: false,
            clubNew: club_fct.object.data,
            modalComment: false,
            openModalPublic: false,
            comment: '',
            editorOption: {
            theme: 'snow',
            
             modules: {
                 
                 toolbar: [
                [{'size': ['small', false, 'large', 'huge']}],
                 ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
                 [{ 'list': 'ordered'}, { 'list': 'bullet' }],
                 [{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
                 ['clean'], ['link'] 
                 ],
                 
             }
        }
        }
    },
     components: {
        EditClub,
        joueurVue,
        importMembres,
        imgFile,
        imgUpload,
        localisation,
        configMembre,
        exportMembres,
        SEditor,
        modalVisible
    },
    watch: {
        myClubsOther(val) {
            this.refresh();
        }
        
    },

    computed: {
        
        oneDemo: {
            get() {
                return this.clubsData.findIndex(elt=>elt.demo === true) != -1;
            }
        },
        myClubsOther: {
            get() {
               if (typeof(this.$store.getters.getUser.clubs) != "undefined") 
                    return this.$store.getters.getUser.clubs.length;
                else
                    return 0;
            }
        }
    },
    methods: {
        concoursTest() {
             this.$router.push({name: 'concours', params: {id: "demo", test: true}}).catch(err=>{})
        },
        closeEdit(club) {
            if (typeof(club)!="undefined") {
                this.openModalPublic = true;
            }
            this.editClubModal  =false;
        },
        dayDiff(d1)
            {
            var today = new Date();
            var d2 = new Date(today.getFullYear(), today.getMonth(), today.getDate())
            var dated1 = new Date(d1);
            dated1 = new Date(dated1.getFullYear(), dated1.getMonth(), dated1.getDate())
            d1 = dated1.getTime();
            d1 = d1 / 86400000;
            d2 = d2.getTime() / 86400000;
            var diff = d1 - d2;
            diff += 5;
            return diff.toFixed(0);
        },
        createClubDemo() {
            this.$store.dispatch("setDemo",{demo: true});
           

        },
        visitClub() {
             this.$router.push({name: 'visit'}).catch(err=>{})
        },
        openModalComment(club) {
            this.modalComment = true;
            if (typeof(club.comment)!="undefined")
                this.comment = club.comment;
            else
                this.comment = "";
            this.club = club;
        },
        deleteComment() {
            this.club.comment = "";
            firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                comment: ""
            })
            this.modalComment=false;
        },
        saveComment() {
            this.club.comment = this.comment;
            firebase_api.api.getDb().collection("club").doc(this.club.id).update({
                comment: this.comment
            })
            this.modalComment=false;
        },
        addClub() {
            this.clubNew = JSON.parse(JSON.stringify(club_fct.object.data));
            this.editClubModal = true;
        },
        clubIsSubscription(club) {
            if (typeof(club.subscription) != "undefined")
                    if (club.subscription.status == "active") {
                        var date = new Date();
                        var endDate = club.subscription.period_end.toDate();
                        var startDate =  club.subscription.period_start.toDate();
                        endDate.setDate(endDate.getDate() + 7);
                        if (startDate < date && date < endDate)
                            return true;
                        else
                            return false;
                    }
                    else
                        return false;
                else
                    false;
        },
        subscribe(club) {
            var successUrl = window.location.origin + "/club";
            var cancelUrl = window.location.origin + "/club";
            var idAuth = this.$store.getters.getUser.authId;
            
            subscription_fct.object.subscribe(idAuth, club, successUrl, cancelUrl);
        },
        setRefreshFile() {
           
           this.$refs["F"+this.clubIdSelected][0].initImage();
        },
        upload(pathFile, idClub) {
          
            this.clubIdSelected = idClub;
            this.uploadPathFile = pathFile + idClub;
            document.getElementById("Supload").click();
        },
        getRole(club) {
            if (typeof(club)!="undefined")
                if (typeof(club.role)=="undefined") {
                    if (typeof(club.users)!="undefined")
                        if (typeof(club.users[this.$store.getters.getUser.authId])!="undefined")
                            return club.users[this.$store.getters.getUser.authId].role;
                }
                else
                    return club.role;
            else
                return null;
        },
        editClub(club) {
            this.club = club;
            this.nav = "edit";
        },
        setLocalisation(club) {
            this.club = club;
            this.nav = "localisation";
        },
        editMembres(club) {
            this.club = club;
            this.nav = "membres";
        },
        add() {
            this.club = JSON.parse(JSON.stringify(club_fct.object.data));
            this.nav = "edit";
        },
        goClubItem(id) {
            this.$router.push({name: "viewClub" , params: {id: id}});
            
        },
        goSeason(id) {
            this.$router.push({name: "saison" , params: {id: id}});
            
        },
        
        refresh() {
            // ICI on va avoir les clubs où l'utilisateur est soit OWNER soit ADMIN
            this.clubsData = this.$store.getters.getMyClubs;
            if (this.clubsData.length==0)
                this.videoOn = true;
            else    
                this.videoOn = false;
            this.nav='list';
            // Seulement il faut rajouter les clubs où l'utilisateur est le joueur
            // pour ca on devrait les retrouver dans le tableau clubs de user courant
            if (typeof(this.$store.getters.getUser.clubs) != "undefined") {
               
                this.$store.getters.getUser.clubs.forEach((clubItemUser, indexClubs) => {
                   
                    var indexClub = this.clubsData.findIndex((clubSearch)=>{
                        if (typeof(clubSearch)!="undefined")
                            return clubSearch.id === clubItemUser.idClub
                        else
                            return false;
                    });
                    // peut être qu'il y est déjà car dans getMyclubs... 
                    // du coup autant mettre tout de suite son rôle !
                    // sinon il faut le rajouter !
                  
                    if (indexClub!=-1) {
                      
                        var clubTempo = this.clubsData[indexClub];
                        var userInClub = clubTempo.users[this.$store.getters.getUser.authId];
                        if (typeof(userInClub)=="undefined")
                            this.clubsData[indexClub].role = "player";
                        else
                            this.clubsData[indexClub].role = userInClub.role;
                    } 
                    else  {
                        club_fct.object.get(clubItemUser.idClub, clubData=>{
                            // dans ce cas il est forcément PLAYER
                            if (typeof(clubData)!="undefined") {
                                clubData.role = "player";
                                this.clubsData.push(clubData);
                            }
                        })
                    }
                })
            }
            var dateCurrent = new Date();
            /*this.$binding("subscriptions", 
                firebase_api.api.getDb().collection("club").doc(this.club.id).collection("subscriptions")
                    .where("current_period_start",">=", dateCurrent).where("current_period_end", "<=", dateCurrent))
              */      
        }
       ,
       home() {
               this.$router.push({name: "home" });
       },
        close() {
             this.$router.push({name: "club" });
        }
    },
   
    mounted() {
       this.refresh();
       
    }
}
</script>